import React from "react";
import { Row, Col, Form } from "antd";
import { Typography, Input, Button } from "../../core";

const layout = {
  wrapperCol: {
    span: 24,
  },
};

const AddTaxForm = ({ onCreate }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    onCreate(values);
    form.resetFields();
  };

  return (
    <Form form={form} {...layout} name="add-tax" onFinish={onFinish}>
      <Row type="flex" justify="space-between" gutter={[16, 16]}>
        <Col sm={12} xs={24}>
          <Form.Item
            name="tax_name"
            rules={[{ required: true, message: "Please input Tax Name!" }]}
          >
            <Input className="text-center" placeholder="Tax Name" />
          </Form.Item>
        </Col>
        <Col sm={12} xs={24}>
          <Form.Item
            name="tax_rate"
            rules={[{ required: true, message: "Please Input Tax Rate" }]}
          >
            <Input
              type="number"
              className="text-center"
              placeholder="Rate in %"
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
          <Typography
            align="center"
            as="h3"
            weight="600"
            color="white"
            text="Add"
          />
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddTaxForm;
